<script lang="ts" setup>
import LtFlag from '~/assets/icons/LT.svg'
import LvFlag from '~/assets/icons/LV.svg'
import GbFlag from '~/assets/icons/GB.svg'
import EeFlag from '~/assets/icons/EE.svg'
import RuFlag from '~/assets/icons/RU.svg'
import { useStoreConfig } from '~/store/storeConfig'
import { useLocale } from '~/composables/useLocale'

const localeSetting = useState<string>('locale.setting')
const storeConfig = useStoreConfig()
const { changeLocale } = useLocale()
const { isWhitelabel, isAmeerikaEestis } = useTheme()

const flags: Record<string, string> = {
  LT: LtFlag,
  LV: LvFlag,
  EN: GbFlag,
  EE: EeFlag,
  RU: RuFlag,
}

const currentLocale = computed(() => localeSetting.value)

const items = computed(() => {
  return Object.keys(storeConfig.getAvailableLocales ?? {}).map((lang) => ({
    data: storeConfig.getAvailableLocales?.[lang],
  }))
})
const localeName = computed(
  () => storeConfig.availableLocales?.[currentLocale.value.toLowerCase()].name ?? currentLocale.value
)
</script>

<template>
  <div class="language-dropdown flex">
    <Dropdown :items="items">
      <template #header>
        <div class="text-text2 dark:text-dmText2 outline-none bg-transparent uppercase flex gap-2 wl:lg:text-white">
          <i v-if="isWhitelabel || isAmeerikaEestis" class="fa-solid fa-globe"></i>
          <img v-else-if="currentLocale" :src="flags[currentLocale.toUpperCase()]" :alt="currentLocale" />
          <template v-if="isWhitelabel || isAmeerikaEestis"> {{ localeName }} </template>
          <template v-else>
            {{ currentLocale }}
          </template>
        </div>
      </template>

      <template #dropdown-item="{ item }">
        <div
          class="flex items-center gap-2"
          :class="{
            active: item.iso === currentLocale,
          }"
          @click="changeLocale(item.iso)">
          <img v-if="item.iso && !isWhitelabel" :src="flags[item.iso.toUpperCase()]" :alt="item.name" />
          {{ item.name }}
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<style lang="postcss" scoped>
.dropdown-item {
  border-radius: theme('vars.borderRadiusHeavy');
}
</style>
